import { TranslatePipe } from '../../../filters/translate.pipe';
import { ItemErrorComponent } from '../../../components/item-form-error/item-form-error.component';
import { ItemFormErrorWithTranslatorComponent } from '../../../components/item-form-error-with-translator/item-form-error-with-translator.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { LoaderOverlayComponent } from '../../../components/loader-overlay/loader-overlay.component';
import { CardChatComponent } from '../../../components/card-chat/card-chat.component';
import Config from '../../../utils/config.service';
import Session from '../../../utils/session.service';
import UrlUtil from '../../../utils/url-util.service';
import ChatService from '../../../services/chat.service';
import ChatRestServices from '../../../services/chat-rest.service';
import UserRestServices from '../../../services/user-rest.service';
import AngularHelperService from '../../../services/angular-helper.service';
import AngularRoutingHelperService from '../../../services/angular-routing-helper.service';
import AngularBroadcastHelperService from '../../../services/angular-broadcast-helper.service';
import RoutingService from '../../../services/routing.service';
import AppLanguageService from '../../../services/app-language.service';

@Component({
	standalone: true,
	selector: 'pre-visit-chat',
	templateUrl: './pre-visit-chat.component.html',
	imports: [
		CommonModule, TranslatePipe, ItemErrorComponent, RouterLink,
		ItemFormErrorWithTranslatorComponent, FormsModule, LoaderOverlayComponent,
		CardChatComponent
	]
})
export default class PreVisitChatComponent implements OnInit {
	private config: Config = inject(Config);
	private session: Session = inject(Session);
	private chatService: ChatService = inject(ChatService); // needed for broadcast loading
	private chatRestServices: ChatRestServices = inject(ChatRestServices);
	private userRestServices: UserRestServices = inject(UserRestServices);
	private urlUtil: UrlUtil = inject(UrlUtil);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularRoutingHelperService: AngularRoutingHelperService = inject(AngularRoutingHelperService);
	private angularBroadcastHelperService: AngularBroadcastHelperService = inject(AngularBroadcastHelperService);
	private routingService: RoutingService = inject(RoutingService);
	private appLanguageService: AppLanguageService = inject(AppLanguageService);
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.routingService.validateAccess('chats').then(() => {
			this.onResolve();
		});
	}
		
	onResolve() {
		var currentSession = this.session.getSession();
		var origin: any = (currentSession && currentSession.user && currentSession.user.origin)
			? currentSession.user.origin
			: 'minudoc.ee';
		this.vm.origin = origin;

		var location: any = window.location.href;
		if (location.includes('eelvisiit')) {
			this.vm.isPrevisit = true;
		}
		
		this.vm.isLanguageMenuOpen = false;
		this.vm.locales = this.appLanguageService.getLanguagesByOrigin(origin);
		var currentSession = this.session.getSession();
		
		this.vm.language = window.navigator.language;
		this.vm.lang = this.session.getSession().user.deviceLanguage || 'et_EE' ;
		this.vm.locale = this.vm.lang;
		this.vm.logoSuffix = this.vm.locale.split('_')[0];
		
		this.vm.setLocale = this.setLocale;
		this.vm.getLocaleOption = this.getLocaleOption;
		
		var id: any = this.angularRoutingHelperService.getRouteParam('id');
		this.chatRestServices.getChatById({ id: id }, (chat) => {
			setTimeout(() => {
				this.vm.selectedChat = chat;
				this.vm.avTestUrl = this.urlUtil.createAvTestUrl();
				if (chat?.privateChatFriend?.firstname) {
					document.title = chat?.privateChatFriend?.firstname + ' ' + chat?.privateChatFriend?.lastname; 
				} else {
					document.title = 'MinuDoc';
				}
				
				var chats: any = this.chatService.getChats();
				if (chats) {
					console.log("Chats: " + Object.keys(chats).length);
				} else {
					console.log("No chats ready");
				}
				this.angularBroadcastHelperService.rootBroadcast(
					this.config.getBroadcastConfig().Session.INIT_CHAT, this.session.getSession()); 
			}, 200);
		});
	}
	
	setLocale(locale) {
		if (this.vm.langDisabled) return;
		this.vm.langDisabled = true;

		var user: any = this.angularHelperService.copy(this.session.getSession().user);
		user.deviceLanguage = locale;

		this.userRestServices.update(user, () => {
			this.angularHelperService.getWindow().location.reload();
		});
	}

	getLocaleOption(locale) {
		return this.appLanguageService.getLanguage(locale);
	}
	
	logoutWithConfirmation(event) {
		this.session.logoutWithConfirmation(event, true);
	}
	
}
